
import store_prestation from '@/store/mods/clinique/prestations'
import $ from 'jquery'

export default {
    name: 'l-bilan-sante',
    components: {},
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,
            all_checked: false,
            one_is_checked: [],
            bilan_santes: [],
        }
    },
    
    computed: {

    },

    mounted() {
        this.fetchBilanSantes()
    },

    methods: {
        fetchBilanSantes() {
            this.is_loading = true
            this.is_load_error = false

            store_prestation.getListeBilanSante().then((response) => {
                this.bilan_santes = response
                this.is_empty = this.bilan_santes.length === 0
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        toutSelectionner() {
            const is_checked = $('#bilan-sante-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = this.bilan_santes.map((bilan) => ({ id: bilan.id, libelle: bilan.libelle }))
            } else {
                this.one_is_checked = []
            }

            this.all_checked = is_checked
        },
    }
}